import { UserOutlined } from "@ant-design/icons";
import { FingerprintOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { Col, Row } from "reactstrap";
import {
  useGetBlockByDistrictQuery,
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";
import swal from "sweetalert";
import { useUpdateEmployeeMutation } from "../UserManagementApiSlice";

const EditProject = ({
  selectedProject,
  employeeDataRefetch,
  employeeData,
  setEditProjectModal,
}) => {
  const { id } = useParams();

  const [projectData, setProjectData] = useState({
    id: "",
    name: "",
    assigned_zone: "",
    assigned_zone_names: "",
    state_options: null,
    district_options: null,
    block_options: null,
    ...selectedProject,
  });

  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(
    projectData.state_options?.value,
    { skip: projectData.assigned_zone === "state" }
  );
  const { data: dataBlock } = useGetBlockByDistrictQuery(
    projectData.district_options?.value,
    { skip: projectData.assigned_zone != "block" }
  );

  const [updateEmployee] = useUpdateEmployeeMutation();

  useEffect(() => {
    if (getStates) setStateList(getStates.data.results);
  }, [getStates]);

  useEffect(() => {
    if (dataDistrict) setDistrictList(dataDistrict.data.results);
  }, [dataDistrict]);

  useEffect(() => {
    if (dataBlock) setBlockList(dataBlock.data.results);
  }, [dataBlock]);

  const ZoneOptions = [
    { value: "state", label: "State" },
    { value: "district", label: "District" },
    { value: "block", label: "Block" },
  ];

  const handleStateOptions = () =>
    stateList.map((state) => ({
      value: state.state_code,
      label: state.state_name,
    }));

  const handleDistrictOptions = () =>
    districtList.map((district) => ({
      value: district.district_code,
      label: district.district_name,
    }));

  const handleBlockOptions = () =>
    blockList.map((block) => ({
      value: block.block_code,
      label: block.block_name,
    }));

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 46,
    }),
  };

  const handleZoneChange = (option) => {
    setProjectData((prev) => ({
      ...prev,
      assigned_zone: option.value,
      state_options: null,
      district_options: null,
      block_options: null,
    }));
  };

  const handleStateChange = (option) => {
    setProjectData((prev) => ({ ...prev, state_options: option }));
    if (projectData.assigned_zone === "state") {
      setProjectData((prev) => ({
        ...prev,
        assigned_zone_names: option.map((d) => d.label),
        assigned_zone_codes: option.map((d) => d.value),
      }));
    } else {
      setProjectData((prev) => ({
        ...prev,
        district_options: [],
        block_options: [],
      }));
    }
  };

  const handleDistrictChange = (option) => {
    setProjectData((prev) => ({ ...prev, district_options: option }));
    if (projectData.assigned_zone === "district") {
      setProjectData((prev) => ({
        ...prev,
        assigned_zone_names: option.map((d) => d.label),
        assigned_zone_codes: option.map((d) => d.value),
      }));
    } else {
      setProjectData((prev) => ({
        ...prev,
        block_options: [],
      }));
    }
  };

  const handleBlockChange = (option) => {
    setProjectData((prev) => ({ ...prev, block_options: option }));
    if (projectData.assigned_zone === "block") {
      setProjectData((prev) => ({
        ...prev,
        assigned_zone_names: option.map((d) => d.label),
        assigned_zone_codes: option.map((d) => d.value),
      }));
    }
  };

  const handleProjectSubmit = () => {
    setIsSubmitting(true);

    let existingProjects = employeeData?.assigned_project;
    if (!Array.isArray(existingProjects)) {
      existingProjects = [];
    }
    updateEmployee({
      id,
      payload: {
        assigned_project: (existingProjects = existingProjects.map(
          (project) => {
            if (project.id === projectData.id) {
              return projectData;
            }
            return project;
          }
        )),
      },
    })
      .unwrap()
      .then((data) => {
        if (data?.success) {
          swal("Employee Data Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Data Updated",
            timer: 1500,
          });
          employeeDataRefetch();
          setEditProjectModal(false);
        } else {
          swal("Missing Fields", {
            buttons: false,
            icon: "warning",
            title: "Please fill Full Details",
            timer: 1500,
          });
        }
      })
      .catch((e) => {
        console.error("Update Error:", e);
        swal("Error occurred", {
          buttons: false,
          icon: "error",
          title: "Something went wrong",
          timer: 3000,
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div>
      <div className="card shadow-md">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <div className="mb-2">
                <FingerprintOutlined
                  size={12}
                  className="me-2 text-secondary"
                />
                <strong>ID:</strong> {selectedProject.id}
              </div>
              <div className="mb-2">
                <UserOutlined size={14} className="me-2 text-primary" />
                <strong>Name:</strong> {selectedProject.name}
              </div>
            </div>
          </div>

          <div className="mt-2">
            <Row>
              <Col lg="6" className="mb-3">
                <label className="text-black mb-1"> Select Zone</label>
                <Select
                  options={ZoneOptions}
                  value={ZoneOptions.find(
                    (z) => z.value === projectData.assigned_zone
                  )}
                  onChange={handleZoneChange}
                  styles={customStyles}
                />
              </Col>
              <Col
                lg={projectData.assigned_zone === "state" ? "12" : "6"}
                className="mb-3"
              >
                <label className="text-black mb-1"> State</label>
                <Select
                  isMulti={projectData.assigned_zone === "state"}
                  options={handleStateOptions()}
                  value={projectData.state_options}
                  onChange={handleStateChange}
                  styles={customStyles}
                  placeholder="Select State"
                />
              </Col>

              {(projectData.assigned_zone === "district" ||
                projectData.assigned_zone === "block") && (
                <Col lg="12" className="mb-3">
                  <label className="text-black mb-1"> District</label>
                  <Select
                    isMulti={
                      projectData.assigned_zone === "district" ? true : false
                    }
                    menuPlacement="auto"
                    options={handleDistrictOptions()}
                    value={projectData.district_options}
                    onChange={handleDistrictChange}
                    placeholder="Select District"
                    styles={customStyles}
                  />
                </Col>
              )}

              {projectData.assigned_zone === "block" && (
                <Col lg="12" className="mb-3">
                  <label className="text-black mb-1"> Block</label>
                  <Select
                    isMulti={
                      projectData.assigned_zone === "block" ? true : false
                    }
                    menuPlacement="auto"
                    options={handleBlockOptions()}
                    value={projectData.block_options}
                    onChange={handleBlockChange}
                    placeholder="Select Block"
                    styles={customStyles}
                  />
                </Col>
              )}
            </Row>
          </div>
        </div>
      </div>

      <Button
        color="success"
        className="saathi-submit-btn px-4 border-success"
        onClick={handleProjectSubmit}
        disabled={isSubmitting}
        size="sm"
      >
        {isSubmitting ? "Submitting..." : "Submit"}
      </Button>
    </div>
  );
};

export default EditProject;
